import React, { useEffect, useContext } from "react";
import { Container } from "react-bootstrap";
import Footer from "../../Footer/Footer";
import Navebar from "../../Navebar/Navebar";
import { LookUpGetAll } from "../../Redux/Actions/LookUpActions";
import { useDispatch } from "react-redux";
import { GlobalData } from "../../App";
import { useLocation } from "react-router-dom";
import "./style.css";

const MainLayout = (WrappedComponent, title) => {
  return function MainLayoutComponent(props) {
    const location = useLocation();

    const dispatch = useDispatch();
    const { SetFilterData } = useContext(GlobalData);
    useEffect(() => {
      dispatch(LookUpGetAll());
    }, [dispatch]);
    const isAllCoursesPath = location.pathname === "/allcourses";
    useEffect(() => {
      if (!isAllCoursesPath) {
        SetFilterData(false);
      }
    }, [isAllCoursesPath, SetFilterData]);

    return (
      <>
        <Navebar />
        <Container fluid className="bg-circle-shapes px-0 ">
          {title && <h1 className="text-center">{title}</h1>}
          <WrappedComponent {...props} />
        </Container>
        <Footer />
      </>
    );
  };
};

export default MainLayout;
